import React from "react";
import DetailsTab from "@/pages/tabs/DetailsTab";

// Lead & CRM context for the bid. Scheduling now lives solely on the dedicated Schedule tab —
// the duplicate mini-timeline that used to sit here was removed in the 2026-06 integrity sweep.
export default function BidSetup({ bid, updateBid, perms, reload }) {
  return (
    <div className="p-4 max-w-[1800px] w-full mx-auto" data-testid="bid-setup">
      <DetailsTab bid={bid} updateBid={updateBid} perms={perms} reload={reload} />
    </div>
  );
}
